// 等待页面加载完成
  document.addEventListener('DOMContentLoaded', function() {
    // 获取滚动容器和导航条
    const carousels = document.querySelectorAll('.mt-video-list_container');

    // 创建视口观察器
  const carouselObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 当轮播图进入视口时，初始化该轮播图
        initCarousel(entry.target);
        // 初始化后取消观察此轮播图
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '200px', // 提前200px开始加载
    threshold: 0.1      // 当10%的元素可见时触发
  });
  
  // 开始观察所有轮播图
  carousels.forEach(carousel => {
    carouselObserver.observe(carousel);
  });
  
  function initCarousel(container){
      const scrollContainer = container.querySelector('.mt-video-list-wrapper');
      const navBar = container.querySelector('.joe-server-logos_nav-bar');
      
      if (scrollContainer && navBar) {
        // 初始化导航条
        updateNavBar(scrollContainer, navBar);
        
        // 监听滚动事件
        scrollContainer.addEventListener('scroll', function() {
          updateNavBar(scrollContainer, navBar);
        });
      }
    };
  });
  
  // 更新导航条位置
  function updateNavBar(scrollContainer, navBar) {
    // 计算滚动位置百分比
    const scrollLeft = scrollContainer.scrollLeft;
    const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    const scrollPercentage = maxScroll > 0 ? scrollLeft / maxScroll : 0;
    
    // 设置导航条宽度（固定为容器的30%）
    const navBarWidth = 30;
    
    // 计算导航条位置（考虑到导航条自身宽度）
    const maxPosition = 100 - navBarWidth;
    const navBarPosition = scrollPercentage * maxPosition;
    
    // 更新导航条
    navBar.style.width = `${navBarWidth}%`;
    navBar.style.left = `${navBarPosition}%`;
    navBar.style.height = '1px'; // 确保可见
  }